import React, { useState, useEffect, useContext, useRef, useMemo } from 'react';
import { AppContext } from '../../../context';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { Wizard, Steps, Step } from 'react-albus';
import { Row, Col, Input, Label, Card, CardBody } from 'reactstrap';
import ReactTooltip from 'react-tooltip';
import _ from 'lodash';
import { renderToString } from 'react-dom/server';

import GraphCard from '../../../components/custom/GraphCard';
import { ThemeColors } from '../../helpers/ThemeColors';

import Layout from '../../../components/custom/Layout';
import ActionIcon from '../../custom/ActionIcon';
import ModalAddNotes from './ModalAddNotes';
import ModalConfirmDelete from './ModalConfirmDelete';
import ModalBreakdownFlightMaster from './ModalBreakdownFlightMaster';
import TopNavigation from '../../../components/wizard-hooks/TopNavigation';
import GenerateBreakdownSheet from './GenerateBreakdownSheet';
import { IMap, IFWB, IStep, PushStep, GoToNextStep, IGraphDonutData, IFHL, IFFM, IFlightTracking } from '../../../globals/interfaces';
import {
    IExtendedFFM,
    IAirline,
    IExtendedULD,
    DeleteLevel,
    AddNotesType
} from './interfaces';
import { extractReactTableData, fileDownload, formatDatetime, formatEmail, getTsDate, notify } from '../../../utils';
import { Button } from 'reactstrap';
import ModalConfirmation from '../../custom/ModalConfirmation';
import { useSetRecoilState } from 'recoil';
import ReactTable from 'react-table';
import styled from 'styled-components';
import ModalFlightManifest from './ModalFlightManifest';
import CustomCard from '../../custom/Card';
import VirtualTable from '../../custom/VirtualTable';
import apiClient from '../../../apiClient';
import Icon from '../../custom/Icon';
import useMawbSummaryData from './useMawbSummaryData';
import useShcs from '../../../customHooks/useShcs';
import ModalMawbsSummary from './ModalMawbsSummary';
import { useSearchAwb } from '../../searchAwb/useSearchAwb';

const { asyncHandler, updateLocalValue } = require('../../../utils');

const colors = ThemeColors();

interface IMawbSummary {
    s_mawb: string;
    s_flight_id: string;
    s_commodity: string;
    s_pieces_type: string;
    distinctUlds: Set<string>;
    distinctUldsCount: number;
    f_weight_total: number;
    s_consignee_name1: string;
    s_destination: string;
}

interface ExtendedAirline extends IAirline {
    d_departure_date: Date;
    t_actual_arrival: Date;
    b_reviewed: boolean;
    flightTracking: IFlightTracking;
}

interface Props {
    manager: boolean;
}

const BreakdownInstructions = ({
    manager
}: Props) => {

    const { user, setLoading } = useContext(AppContext);
    const { handleSearchAwb } = useSearchAwb();

    const [modalConfirmationBreakdownFlightByHawb, setModalConfirmationBreakdownFlightByHawb] = useState(false);
    const [d_arrival_date, set_d_arrival_date] = useState(moment().format('YYYY-MM-DD'));
    const [ffmData, setFfmData] = useState<Array<IExtendedFFM>>([]);
    const [uniqueAirlines, setUniqueAirlines] = useState<Array<ExtendedAirline>>([]);
    const [ulds, setUlds] = useState<Array<IExtendedULD>>([]);
    const uldTableRef = useRef<HTMLDivElement>(null);

    const [s_flight_id, set_s_flight_id] = useState('');
    const [selectedUld, setSelectedUld] = useState<IExtendedULD>();
    const [selectedAwb, setSelectedAwb] = useState<IExtendedFFM>();
    const [acceptedUlds, setAcceptedUlds] = useState(0);
    const [modal, setModal] = useState(false);
    const [type, setType] = useState<AddNotesType>('uld');
    const [fwbData, setFwbData] = useState<IFWB>();
    const [selectedHawbRecord, setSelectedHawbRecord] = useState<IFHL>();
    const [selectedHouseSerial, setSelectedHouseSerial] = useState('');

    const [modalDelete, setModalDelete] = useState(false);
    const [deleteLevel, setDeleteLevel] = useState<DeleteLevel>('AWB');
    const [deleteFlight, setDeleteFlight] = useState('');
    const [deleteUld, setDeleteUld] = useState('');
    const [deleteId, setDeleteId] = useState('');
    const [deleteAwb, setDeleteAwb] = useState('');
    const [selectedFlight, setSelectedFlight] = useState<ExtendedAirline>();
    const [modalBreakdownFlightMaster, setModalBreakdownFlightMaster] = useState(false);
    const [mawbSummary, setMawbSummary] = useState<Array<IMawbSummary>>([]);
    const mawbTableRef = useRef<HTMLDivElement>(null);
    const [modalFlightManifest, setModalFlightManifest] = useState(false);
    const {
        mawbSummaryFFMs,
        selectedShcs,
        setSelectedShcs,
        getMawbSummaryData,
        breakdownInstructionsMawbSummaryUpdateShc
    } = useMawbSummaryData();
    const shcs = useShcs();
    const [modalMawbSummary, setModalMawbSummary] = useState(false);
    const [loadingMawbSummary, setLoadingMawbSummary] = useState(false);

    const ffmQuery = asyncHandler(async () => {
        setLoading(true);

        const res = await apiClient.post('/selectFfmByFlightArrivalDateAndPouWithFwb', {
            d_arrival_date,
            s_unit: user.s_unit
        });
        const { ffmData, flightTrackingDataMap } = res.data;
        setFfmData(ffmData);
        setUniqueAirlines(resolveUniqueAirlines(ffmData, flightTrackingDataMap));
        setLoading(false);
        // setMawbSummary(resolveMawbSummary(res.data));
    });

    const resolveUniqueAirlines = (ffmData: Array<IExtendedFFM>, flightTrackingDataMap: Record<string, IFlightTracking>) => {
        const airlines: IMap<ExtendedAirline> = {};
        for (let i = 0; i < ffmData.length; i++) {
            const {
                s_flight_id,
                i_unique,
                s_flight_number,
                s_logo,
                s_status,
                s_modified_by,
                t_modified,
                d_departure_date,
                t_actual_arrival
            } = ffmData[i];

            const key = `${s_flight_id}-${i_unique}`;
            const flightTracking = flightTrackingDataMap[key];
            const b_reviewed = _.get(flightTracking, 'b_reviewed', false);

            if (airlines[key] === undefined) {
                airlines[key] = {
                    s_flight_number: s_flight_number,
                    s_flight_id: s_flight_id,
                    s_logo: s_logo,
                    s_status: s_status,
                    s_modified_by: s_modified_by,
                    t_modified: t_modified,
                    d_departure_date: d_departure_date,
                    t_actual_arrival: t_actual_arrival,
                    b_reviewed,
                    flightTracking
                }
            }
        }

        const airlinesArray = [];
        for (let key in airlines) {
            airlinesArray.push(airlines[key])
        }
        return airlinesArray;
    }

    const resolveMawbSummary = (ulds: Array<IExtendedULD>) => {
        const ffms: Array<IExtendedFFM> = [];
        for (const uld of ulds) {
            ffms.push(...uld.awbs);
        }

        const map: Record<string, IMawbSummary> = {};
        for (const { s_mawb, s_flight_id, s_commodity, s_pieces_type, s_uld, f_weight, s_consignee_name1, s_destination } of ffms) {
            if (!map[s_mawb]) {
                map[s_mawb] = {
                    s_mawb,
                    s_flight_id,
                    s_commodity,
                    s_pieces_type,
                    distinctUlds: new Set(),
                    distinctUldsCount: 0,
                    f_weight_total: 0,
                    s_consignee_name1,
                    s_destination
                }
            }
            map[s_mawb].distinctUlds.add(s_uld);
            map[s_mawb].f_weight_total += f_weight;
        }
        const array: Array<IMawbSummary> = [];
        for (const key in map) {
            map[key].distinctUldsCount = map[key].distinctUlds.size;
            array.push(map[key]);
        }
        return array;
    }

    useEffect(() => {
        ffmQuery();
        setUlds([]);
        setSelectedUld(undefined);
        setSelectedAwb(undefined);
        set_s_flight_id('');
    }, [user.s_unit, d_arrival_date]);

    const selectUldsByFlight = asyncHandler(async () => {
        setLoading(true);
        const flightAwbs = ffmData.filter(ffm => ffm.s_flight_id === s_flight_id);
        const res = await apiClient.post('/selectUldsByFlight', {
            data: {
                s_flight_id: s_flight_id,
                i_unique: _.get(flightAwbs, '[0].i_unique', ''),
                s_pou: user && user.s_destination,
                flightAwbs
            }
        });
        setLoading(false);
        const uldsArray = res.data;
        setMawbSummary(resolveMawbSummary(uldsArray));
        setUlds(uldsArray);
        resolveGraphData(uldsArray);
    });

    const updateAwbs = (s_mawb: string, s_flight_id: string, reverse?: boolean) => {
        const udpateType = reverse ? false : true;
        setFfmData(prev => {
            const copy = _.cloneDeep(prev);
            for (const ffm of copy) {
                if (ffm.s_mawb === s_mawb && ffm.s_flight_id === s_flight_id) {
                    ffm.b_breakdown_hawb = udpateType;
                }
            }
            return copy;
        });

        setUlds(prev => {
            const copy = _.cloneDeep(prev);
            for (const uld of copy) {
                if (uld.s_flight_id === s_flight_id) {
                    const awbsCopy = _.cloneDeep(uld.awbs);
                    for (const awb of awbsCopy) {
                        if (awb.s_mawb === s_mawb) {
                            awb.b_breakdown_hawb = udpateType;
                        }
                    }
                    uld.awbs = awbsCopy;
                }
            }
            return copy;
        });

        setSelectedUld(prev => {
            if (!prev) return prev;
            if (prev.s_flight_id !== s_flight_id) return;

            const copy = _.cloneDeep(prev);
            const { awbs } = copy;
            for (const awb of awbs) {
                if (awb.s_mawb === s_mawb) {
                    awb.b_breakdown_hawb = udpateType;
                }
            }
            return copy;
        });
    }

    useEffect(() => {
        if (s_flight_id && s_flight_id.length > 0) {
            selectUldsByFlight();
        }
    }, [s_flight_id]);

    const getBreakdownAdditionalData = asyncHandler(async (s_mawb: string) => {
        const res = await apiClient.post('/getBreakdownAdditionalData', {
            data: {
                s_mawb
            }
        });

        const { fwbData } = res.data;

        setFwbData(fwbData);
    });

    const handleAddUldNotes = (item: IExtendedULD) => {
        setSelectedUld(item);
        setType('uld');
        setModal(true);
    }


    const handleAddAwbNotes = (awb: IExtendedFFM) => {
        setSelectedAwb(awb);
        setType('awb');
        setModal(true);
        getBreakdownAdditionalData(awb.s_mawb);
    }

    const addBreakdownNotes = asyncHandler(async (values: IMap<any>) => {
        if (selectedUld) {
            const data = values;

            data.type = type;

            if (type === 'uld') {
                data.id = selectedUld.id;
            } else if (type === 'awb' && selectedAwb) {
                data.id = selectedAwb.id;
                data.s_mawb = selectedAwb.s_mawb;
                data.s_hawb = selectedHouseSerial;
            }

            data.t_modified = moment().local().format('MM/DD/YYYY HH:mm:ss');
            data.s_modified_by = user.s_email;

            const res = await apiClient.post('/addBreakdownNotes', {
                data
            });

            if (type === 'uld') {
                updateLocalValue(ulds, setUlds, selectedUld.id, res.data[0]);
            } else if (selectedAwb) {
                const updated = res.data[0];

                const uldsCopy = _.cloneDeep(ulds);
                uldsCopy.map((uld: IExtendedULD) => {
                    const { awbs } = uld;
                    for (let i = 0; i < awbs.length; i++) {
                        if (awbs[i].id === selectedAwb.id) {
                            updated.hasHawb = awbs[i].hasHawb;
                            updated.hawbs = awbs[i].hawbs;
                            const copy = { ...updated };
                            awbs[i] = copy;
                            const uldCopy = { ...uld };
                            setSelectedUld(uldCopy);
                            break;
                        }
                    }
                });

                setUlds(uldsCopy);
            }

            setModal(false);
            notify('Notes Saved');
        }
    });

    const breakdownUldsByHouse = async () => {
        setLoading(true);
        const res = await apiClient.put('/breakdownUldsByHouse', {
            s_flight_id,
            s_modified_by: user.s_email,
            t_modified: moment().local().format('MM/DD/YYYY HH:mm')
        });
        if (res.status === 204) {
            setFfmData((prev) =>
                prev.map((ffm) => {
                    if (ffm.s_flight_id === s_flight_id) {
                        const copy = _.cloneDeep(ffm);
                        copy.b_breakdown_hawb = true;
                        return copy;
                    } else {
                        return ffm;
                    }
                })
            );
            notify('Success');
        }
        setLoading(false);
    }

    const handleDelete = (level: DeleteLevel, flight: string, uld?: string, id?: string, s_mawb?: string) => {
        setDeleteLevel(level);
        setDeleteFlight(flight);
        setDeleteUld(uld || '');
        setDeleteId(id || '');
        setModalDelete(true);
        if (s_mawb) {
            setDeleteAwb(s_mawb);
        }
    }

    const confirmDelete = asyncHandler(async () => {
        let endpoint;
        const data = {
            s_flight_id: deleteFlight,
            s_modified_by: user.s_email,
            t_modified: moment().local().format('MM/DD/YYYY HH:mm:ss')
        };

        if (deleteLevel === 'FLIGHT') {
            endpoint = 'markFlightDeleted';
        } else if (deleteLevel === 'ULD') {
            endpoint = 'markUldDeleted';
            // @ts-ignore
            data.s_uld = deleteUld;
        } else {
            endpoint = 'markAwbDeleted';
            // @ts-ignore
            data.s_uld = deleteUld;
            // @ts-ignore
            data.s_mawb = deleteAwb;
        }

        await apiClient.post(`/${endpoint}`, data);

        setModalDelete(false);
        ffmQuery();

        if (deleteLevel === 'FLIGHT') {
            set_s_flight_id('');
            setUlds([]);
        } else if (deleteLevel === 'ULD') {
            selectUldsByFlight();
            setSelectedUld(undefined);
        } else {
            setSelectedUld(undefined);
        }

    });

    const handleSelectFlight = (flight: ExtendedAirline) => {
        setSelectedFlight(flight);
        set_s_flight_id(flight.s_flight_id);
    }

    useEffect(() => {
        const selectedHouse = _.get(selectedAwb, 'hawbs', []).find(h => h.s_hawb === selectedHouseSerial);
        setSelectedHawbRecord(selectedHouse || undefined);
    }, [selectedAwb, selectedHouseSerial]);

    useEffect(() => {
        const hawbs = _.get(selectedAwb, 'hawbs', []);
        setSelectedHawbRecord(hawbs.length > 0 ? hawbs[0] : undefined);
    }, [selectedAwb]);

    const topNavClick = (stepItem: IStep, push: PushStep, step: IStep) => {
        Number(stepItem.id) < Number(step.id) && push(stepItem.id);
    };

    const onClickNext = (
        goToNext: GoToNextStep,
        steps: Array<IStep>,
        step: IStep
    ) => {
        step.isDone = true;
        if (steps.length - 1 <= steps.indexOf(step)) {
            return;
        } else if (!resolveEnableNext(step)) {
            step.disabled = true;
            return;
        } else {
            step.disabled = false;
            goToNext();
        }
    };

    const resolveEnableNext = (step: any) => {
        // console.log(step);
        // if (step.id === '1') {
        //     console.log(s_flight_id);
        //     return _.get(s_flight_id, 'length', 0) > 0;
        // } else if (step.id === '2') {
        //     return selectedUld && selectedUld.id !== null && selectedUld.id !== undefined;
        // } else {
        //     return true;
        // }
        return true;
    }

    const [graphData, setGraphData] = useState<IGraphDonutData>();

    const resolveGraphData = (data: Array<IExtendedULD>) => {
        // b_accepted becomes 0 when b_closed = 1, so instead of using those values check status instead:
        const numAccepted = data.reduce((total, current) => total += ['ACCEPTED', 'CLOSED'].includes(current.s_status) ? 1 : 0, 0);

        const graphData: any = {
            labels: ['Accepted', 'Not Accepted'],
            datasets: [
                {
                    // @ts-ignore
                    label: 'Acceptance Status',
                    borderColor: [colors.themeColor1, 'grey'],
                    backgroundColor: [colors.themeColor1_10, 'white'],
                    borderWidth: 2,
                    data: [numAccepted, data.length - numAccepted],
                },
            ],
        };

        setAcceptedUlds(numAccepted);
        setGraphData(graphData);
    }

    const printBreakdownSheet = (singleUld: boolean) => {
        const sheet = renderToString(
            <GenerateBreakdownSheet
                user={user}
                selectedFlight={selectedFlight}
                ulds={ulds}
                singleUld={singleUld}
                selectedUld={selectedUld}
            />
        );

        const myWindow = window.open("", "MsgWindow", "width=1920,height=1080");
        // myWindow.document.querySelector('html').remove();
        // @ts-ignore
        myWindow.document.body.innerHTML = null;
        // @ts-ignore
        myWindow.document.write(sheet);
    }

    const handleDownloadMawbSummary = () => {
        const data = extractReactTableData(mawbTableRef, ['index', 'distinctUlds']);
        fileDownload(data, `${s_flight_id} MAWB Summary.csv`);
    }

    const handleDownloadUldsSummary = () => {
        const data = extractReactTableData(uldTableRef, ['index', 'awbs']);
        fileDownload(data, `${s_flight_id} ULD Summary.csv`);
    }

    const downloadYop = async () => {
        try {
            const res = await apiClient.get(`/yop-sheet-data?d_arrival_date=${d_arrival_date}&s_unit=${user.s_unit}`);
            const sortedData = res.data;

            const sortByArrival = (a, b) => {
                const timeA = a['Actual Arrival'] ? moment(a['Actual Arrival']).valueOf() : null;
                const timeB = b['Actual Arrival'] ? moment(b['Actual Arrival']).valueOf() : null;

                if (timeA === null && timeB !== null) return 1; // Null values go last
                if (timeA !== null && timeB === null) return -1;
                if (timeA === null && timeB === null) return 0;

                return timeA - timeB; // Compare by numeric timestamp
            };

            sortedData.sort((a, b) => {
                const arrivalDateComparison = sortByArrival(a, b);
                if (arrivalDateComparison !== 0) {
                    return arrivalDateComparison;
                }

                const flightSerialComparison = a['Flight Serial'].localeCompare(b['Flight Serial']);
                if (flightSerialComparison !== 0) {
                    return flightSerialComparison;
                }

                // Third level of sorting by ULD (alphanumeric)
                return a['ULD'].localeCompare(b['ULD'], undefined, { numeric: true, sensitivity: 'base' });
            });

            const finalData = sortedData.map((item, i) => {
                return {
                    '#': i + 1,
                    ...item,
                    'Actual Arrival': item['Actual Arrival'] ? moment.utc(item['Actual Arrival']).format('HH:mm') : ''
                }
            });

            // sort ULD
            fileDownload(finalData, `ULD Breakdown Instructions ${d_arrival_date}.csv`);
        } catch (err) {
            alert(err);
        }
    }

    const reviewFlight = async () => {
        try {
            const flightFFM = ffmData.find(item => item.s_flight_id = s_flight_id);
            if (!flightFFM) return;

            const res = await apiClient.post(`/reviewFlight`, {
                s_flight_id,
                i_unique: flightFFM.i_unique,
                b_reviewed: true,
                s_reviewed_by: user.s_email,
                t_reviewed: getTsDate(),
                s_modified_by: user.s_email,
                t_modified: getTsDate()
            });

            const flightTracking: IFlightTracking = res.data;
            setSelectedFlight(prev => {
                const copy = _.cloneDeep(prev);
                copy.b_reviewed = true;
                copy.flightTracking = flightTracking;
                return copy;
            });

            setUniqueAirlines(prev => {
                const copy = _.cloneDeep(prev);
                for (const item of copy) {
                    if (item.s_flight_id === flightTracking.s_flight_id) {
                        item.b_reviewed = true;
                        item.flightTracking = flightTracking;
                    }
                }
                return copy;
            });
            notify('Flight Reviewed');
        } catch (err) {
            alert(err);
        }
    }

    const handleSearchMawbSummary = async (item: IMawbSummary) => {
        const { s_mawb, s_flight_id } = item;
        setLoading(true);
        await getMawbSummaryData(s_mawb, s_flight_id);
        setModalMawbSummary(true);
        setLoading(false);
    }

    const handleBreakdownInstructionsMawbSummaryUpdateShc = async () => {
        setLoadingMawbSummary(true);
        await breakdownInstructionsMawbSummaryUpdateShc();
        setLoadingMawbSummary(false);
        setModalMawbSummary(false);
        notify('Updated');
    }

    return (
        <Layout>
            <Row className='py-3'>
                <Col md={12}>
                    <Row>
                        <Col md={12}>
                            <h1>
                                {
                                    manager ?
                                        'Import Flight Manager' :
                                        'Breakdown Instructions'
                                }
                            </h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <Card>
                                <CardBody className="wizard wizard-default">
                                    <Wizard>
                                        <TopNavigation
                                            className="justify-content-center"
                                            disableNav={false}
                                            topNavClick={topNavClick}
                                        />
                                        <Steps>
                                            <Step id="1" name={'Step 1'} desc={'Select Flight'}>
                                                <div className="wizard-basic-step">
                                                    <FlexContainer>
                                                        <FlightsContainer>
                                                            <CustomCard>
                                                                <FlexContainer>
                                                                    <FlexGap>
                                                                        <Label className='d-inline mr-2'>Select Departure Date</Label>
                                                                        <Input type='date' value={d_arrival_date} onChange={(e: any) => set_d_arrival_date(e.target.value)} className='d-inline' style={{ width: '200px' }} />
                                                                    </FlexGap>
                                                                    <Icon
                                                                        className='fa-duotone fa-solid fa-file-spreadsheet'
                                                                        onClick={downloadYop}
                                                                        dataTip='ULD Breakdown Instructions'
                                                                        size={40}
                                                                        simulateLoading
                                                                    />
                                                                </FlexContainer>

                                                                <Row className='mt-2'>
                                                                    <Col md={12}>
                                                                        <VirtualTable<ExtendedAirline>
                                                                            data={uniqueAirlines}
                                                                            mapping={[
                                                                                {
                                                                                    name: 'Flight',
                                                                                    value: 's_logo',
                                                                                    image: true,
                                                                                    square: true
                                                                                },
                                                                                {
                                                                                    name: 'Airline',
                                                                                    value: 's_flight_number',
                                                                                    customWidth: 100
                                                                                },
                                                                                {
                                                                                    name: 'Flight Date',
                                                                                    value: 'd_departure_date',
                                                                                    date: true,
                                                                                    utc: true
                                                                                },
                                                                                {
                                                                                    name: 'Actual Arrival',
                                                                                    value: 't_actual_arrival',
                                                                                    time: true,
                                                                                    utc: true,
                                                                                    customWidth: 100
                                                                                },
                                                                                {
                                                                                    name: 'Reviewed',
                                                                                    value: 'fas fa-circle-check',
                                                                                    icon: true,
                                                                                    showCondition: item => item.b_reviewed,
                                                                                    customWidth: 70
                                                                                },
                                                                                {
                                                                                    name: '',
                                                                                    value: 'fas fa-trash',
                                                                                    icon: true,
                                                                                    showCondition: () => manager === true,
                                                                                    function: (item: IAirline) => handleDelete('FLIGHT', item.s_flight_id)
                                                                                }
                                                                            ]}
                                                                            numRows={7}
                                                                            enableClick={true}
                                                                            handleClick={(item) => handleSelectFlight(item)}
                                                                            locked={true}
                                                                            wizardNext={true}
                                                                            onClickNext={onClickNext}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                            </CustomCard>
                                                        </FlightsContainer>
                                                        {
                                                            (s_flight_id.length > 0 && graphData && graphData.datasets) &&
                                                            <GraphContainer>
                                                                {
                                                                    (ulds && ulds.length > 0) ?
                                                                        <GraphCard
                                                                            type={'doughnut'}
                                                                            title={
                                                                                <div>
                                                                                    <h4>ULDs for {s_flight_id}</h4>
                                                                                    <h4>{acceptedUlds} / {ulds.length} Accepted</h4>
                                                                                </div>
                                                                            }
                                                                            graphData={graphData}
                                                                            height={'500px'}
                                                                        /> :
                                                                        <div>
                                                                            <h4>ULDs for {s_flight_id}</h4>
                                                                            <h4>{acceptedUlds} / {ulds.length} Accepted</h4>
                                                                        </div>
                                                                }
                                                            </GraphContainer>
                                                        }
                                                    </FlexContainer>
                                                </div>
                                            </Step>
                                            <Step id="2" name={'Step 2'} desc={'Select ULD'}>
                                                <div className="wizard-basic-step">
                                                    {
                                                        s_flight_id.length > 0 &&
                                                        <div>
                                                            <CustomCard>
                                                                <FlightReview
                                                                    selectedFlight={selectedFlight}
                                                                    reviewFlight={reviewFlight}
                                                                    ulds={ulds}
                                                                />
                                                                <FlexContainer>
                                                                    <h4>ULDs in Flight {s_flight_id}</h4>
                                                                    <ReactTooltip />
                                                                    <IconsContainer>
                                                                        <i
                                                                            className={'fa-solid fa-memo-circle-info text-success hover'}
                                                                            data-tip={'Breakdown by TYPE'}
                                                                            onClick={() => setModalBreakdownFlightMaster(true)}
                                                                            style={{ fontSize: '36px' }}
                                                                        />
                                                                        <i
                                                                            className={'fa-solid fa-clipboard-list text-success hover'}
                                                                            data-tip={'Import Flight Manifest'}
                                                                            onClick={() => setModalFlightManifest(true)}
                                                                            style={{ fontSize: '36px' }}
                                                                        />
                                                                        <ActionIcon
                                                                            type={'print'}
                                                                            onClick={() => printBreakdownSheet(false)}
                                                                        />
                                                                        <ActionIcon
                                                                            type={'download'}
                                                                            onClick={() => handleDownloadUldsSummary()}
                                                                        />
                                                                    </IconsContainer>
                                                                </FlexContainer>
                                                                <VirtualTable<IExtendedULD>
                                                                    data={ulds}
                                                                    mapping={[
                                                                        {
                                                                            name: 'ULD',
                                                                            value: 's_uld',
                                                                            customWidth: 180
                                                                        },
                                                                        {
                                                                            name: 'SHC',
                                                                            value: 's_shc'
                                                                        },
                                                                        {
                                                                            name: 'MAWB Count',
                                                                            value: 'mawbCount',
                                                                            number: true
                                                                        },
                                                                        {
                                                                            name: 'Destinations',
                                                                            value: 'destinations'
                                                                        },
                                                                        {
                                                                            name: 'Total Weight',
                                                                            value: 'totalWeight',
                                                                            number: true,
                                                                            decimal: true
                                                                        },
                                                                        {
                                                                            name: '',
                                                                            value: 'fas fa-edit',
                                                                            icon: true,
                                                                            function: (item: IExtendedULD) => handleAddUldNotes(item)
                                                                        },
                                                                        {
                                                                            name: '',
                                                                            value: 'fas fa-trash',
                                                                            icon: true,
                                                                            showCondition: () => manager === true,
                                                                            function: (item: IExtendedULD) => handleDelete('ULD', item.s_flight_id, item.s_uld)
                                                                        }
                                                                    ]}
                                                                    numRows={10}
                                                                    enableClick={true}
                                                                    handleClick={(item) => setSelectedUld(item)}
                                                                    wizardNext={true}
                                                                    onClickNext={onClickNext}
                                                                    reactTableRef={uldTableRef}
                                                                />
                                                            </CustomCard>
                                                            <CustomCard className={'mt-3'}>
                                                                <FlexContainer>
                                                                    <h4>MAWB Summary</h4>
                                                                    <ActionIcon
                                                                        type={'download'}
                                                                        onClick={() => handleDownloadMawbSummary()}
                                                                    />
                                                                </FlexContainer>
                                                                <VirtualTable
                                                                    data={mawbSummary}
                                                                    mapping={[{
                                                                        name: 'MAWB',
                                                                        value: 's_mawb',
                                                                        s_mawb: true
                                                                    }, {
                                                                        name: 'Des',
                                                                        value: 's_destination',
                                                                        smallWidth: true
                                                                    }, {
                                                                        name: 'Commodity',
                                                                        value: 's_commodity'
                                                                    }, {
                                                                        name: 'Piece Type',
                                                                        value: 's_pieces_type'
                                                                    }, {
                                                                        name: 'Distinct ULD Count',
                                                                        value: 'distinctUldsCount',
                                                                        number: true
                                                                    }, {
                                                                        name: 'Weight Total',
                                                                        value: 'f_weight_total',
                                                                        number: true,
                                                                        decimal: true
                                                                    }, {
                                                                        name: 'Consignee',
                                                                        value: 's_consignee_name1'
                                                                    }, {
                                                                        name: 'Destination',
                                                                        value: 's_destination',
                                                                        center: true,
                                                                        customWidth: 100
                                                                    }, {
                                                                        name: '',
                                                                        value: 'fas fa-edit',
                                                                        icon: true,
                                                                        function: (item: IMawbSummary) => handleSearchMawbSummary(item)
                                                                    }]}
                                                                    numRows={10}
                                                                    reactTableRef={mawbTableRef}
                                                                />
                                                            </CustomCard>
                                                        </div>
                                                    }
                                                </div>
                                            </Step>
                                            <Step id="3" name={'Step 3'} desc={'Select AWB'}>
                                                <div className="wizard-basic-step">
                                                    <Row>
                                                        {
                                                            (selectedUld && selectedUld.id) &&
                                                            <Col md={12} className={'px-1'}>
                                                                <CustomCard style={{ borderRadius: '0.75rem' }}>
                                                                    <CardBody>
                                                                        <Row>
                                                                            <Col md={12}>
                                                                                <h4 className={'float-left'}>AWBs in {selectedUld.s_uld} in Flight {s_flight_id}</h4>
                                                                                <i
                                                                                    className={'fad fa-print text-success text-large float-right hover-pointer'}
                                                                                    onClick={() => printBreakdownSheet(true)}
                                                                                ></i>
                                                                            </Col>
                                                                        </Row>
                                                                        <VirtualTable
                                                                            data={selectedUld.awbs}
                                                                            mapping={[
                                                                                {
                                                                                    name: 'AWB',
                                                                                    value: 's_mawb',
                                                                                    s_mawb: true
                                                                                },
                                                                                {
                                                                                    name: 'Dest',
                                                                                    value: 's_destination',
                                                                                    smallWidth: true
                                                                                },
                                                                                {
                                                                                    name: 'Status',
                                                                                    value: 's_status'
                                                                                },
                                                                                {
                                                                                    name: 'Type',
                                                                                    value: 's_pieces_type',
                                                                                    smallWidth: true
                                                                                },
                                                                                {
                                                                                    name: 'SHC',
                                                                                    value: 's_special_handling_code'
                                                                                },
                                                                                {
                                                                                    name: 'Has House',
                                                                                    value: 'hasHawb',
                                                                                    boolean: true
                                                                                },
                                                                                {
                                                                                    name: 'Breakdown by House',
                                                                                    value: 'b_breakdown_hawb',
                                                                                    boolean: true
                                                                                },
                                                                                {
                                                                                    name: '',
                                                                                    value: 'fas fa-edit',
                                                                                    icon: true,
                                                                                    function: (item: IExtendedFFM) => handleAddAwbNotes(item)
                                                                                },
                                                                                {
                                                                                    name: '',
                                                                                    value: 'fas fa-trash',
                                                                                    icon: true,
                                                                                    showCondition: () => manager === true,
                                                                                    function: (item: IExtendedFFM) => handleDelete('AWB', item.s_flight_id, item.s_uld, String(item.id), item.s_mawb)
                                                                                }
                                                                            ]}
                                                                            numRows={12}
                                                                            locked={true}
                                                                            enableClick={true}
                                                                            handleClick={(item) => setSelectedAwb(item)}
                                                                        />
                                                                    </CardBody>
                                                                </CustomCard>
                                                            </Col>
                                                        }
                                                    </Row>
                                                </div>
                                            </Step>
                                        </Steps>
                                    </Wizard>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                </Col>
            </Row>

            <ModalAddNotes
                modal={modal}
                setModal={setModal}
                type={type}
                s_flight_id={s_flight_id}
                selectedUld={selectedUld}
                selectedAwb={selectedAwb}
                addBreakdownNotes={addBreakdownNotes}
                fwbData={fwbData}
                selectedHawbRecord={selectedHawbRecord}
                setSelectedHouseSerial={setSelectedHouseSerial}
                handleSearchAwb={handleSearchAwb}
            />

            <ModalConfirmDelete
                modal={modalDelete}
                setModal={setModalDelete}
                deleteLevel={deleteLevel}
                deleteFlight={deleteFlight}
                deleteUld={deleteUld}
                deleteId={deleteId}
                confirmDelete={confirmDelete}
                selectedFlight={selectedFlight}
                selectedUld={selectedUld}
                selectedAwb={selectedAwb}
            />

            <ModalBreakdownFlightMaster
                modal={modalBreakdownFlightMaster}
                setModal={setModalBreakdownFlightMaster}
                ulds={ulds}
                s_flight_id={s_flight_id}
                user={user}
                updateAwbs={updateAwbs}
                setModalConfirmationBreakdownFlightByHawb={setModalConfirmationBreakdownFlightByHawb}
            />

            <ModalConfirmation
                modal={modalConfirmationBreakdownFlightByHawb}
                setModal={setModalConfirmationBreakdownFlightByHawb}
                message={'Update entire flight to breakdown by HAWB?'}
                confirm={() => breakdownUldsByHouse()}
            />

            <ModalFlightManifest
                user={user}
                s_flight_id={s_flight_id}
                d_arrival_date={d_arrival_date}
                modal={modalFlightManifest}
                setModal={setModalFlightManifest}
            />

            <ModalMawbsSummary
                modal={modalMawbSummary}
                setModal={setModalMawbSummary}
                mawbSummaryFFMs={mawbSummaryFFMs}
                shcs={shcs}
                selectedShcs={selectedShcs}
                setSelectedShcs={setSelectedShcs}
                loadingMawbSummary={loadingMawbSummary}
                handleBreakdownInstructionsMawbSummaryUpdateShc={handleBreakdownInstructionsMawbSummaryUpdateShc}
            />
        </Layout>
    );
}

const FlightReview = ({
    selectedFlight,
    reviewFlight,
    ulds

}: {
    selectedFlight: ExtendedAirline;
    reviewFlight: () => Promise<void>;
    ulds: Array<IExtendedULD>;
}) => {

    if (!selectedFlight.b_reviewed) {
        return (
            <h4>
                Flight Review
                <Icon
                    className='fa-duotone fa-light fa-plane-circle-check text-success ml-2'
                    size={24}
                    dataTip='Click to complete review'
                    onClick={reviewFlight}
                    disabled={!ulds.length}
                />
            </h4>
        );
    }

    const { flightTracking } = selectedFlight;

    return (
        <h4>Flight reviewed by {formatEmail(flightTracking.s_reviewed_by)} on {formatDatetime(flightTracking.t_reviewed)}</h4>
    );
}

export default withRouter(BreakdownInstructions);

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 5px;
`;

const FlexGap = styled.div`
    display: flex;
    gap: 5px;
`;

const FlightsContainer = styled.div`
    width: 650px;
`;

const GraphContainer = styled.div`
    flex: 1;
`;

const IconsContainer = styled.div`
    display: flex;
    gap: 10px;
`;

const YupSheetIcon = styled.i`
    font-size: 40px;

    &:hover {
        cursor: pointer;
    }
`;
